import { useTranslation } from 'react-i18next';
import ScrollReveal from '@/components/base/ScrollReveal';

const techniques = [
  {
    titleKey: 'technique_shari_title',
    descKey: 'technique_shari_desc',
    imageUrl: 'https://storage.helloreaddy.io/project_files/fbab44cd-04c6-492b-a442-ed8f359ae362/2a60922a-ff35-42ab-b573-8f70fb0ce7c5_compressed_-2026-09-06-16.21.56.webp',
  },
  {
    titleKey: 'technique_jukusei_title',
    descKey: 'technique_jukusei_desc',
    imageUrl: 'https://storage.helloreaddy.io/project_files/fbab44cd-04c6-492b-a442-ed8f359ae362/ca1bb595-9b7e-4d3b-9521-dc76308c085b_compressed_unnamed.webp',
  },
  {
    titleKey: 'technique_shimeru_title',
    descKey: 'technique_shimeru_desc',
    imageUrls: [
      'https://storage.helloreaddy.io/project_files/fbab44cd-04c6-492b-a442-ed8f359ae362/71eb87e0-3207-4099-985f-573aa873d3e0_compressed_unnamed.webp',
      'https://storage.helloreaddy.io/project_files/fbab44cd-04c6-492b-a442-ed8f359ae362/eaad3f3c-bab4-48af-bce2-e14354d5aaed_compressed_unnamed.webp',
    ],
  },
];

const ingredients = [
  { titleKey: 'sourcing_market_title', descKey: 'sourcing_market_desc' },
  { titleKey: 'sourcing_season_title', descKey: 'sourcing_season_desc' },
  { titleKey: 'sourcing_condiments_title', descKey: 'sourcing_condiments_desc' },
];

const headerBgImage = 'https://storage.helloreaddy.io/project_files/fbab44cd-04c6-492b-a442-ed8f359ae362/aa133f5c-b70f-41c6-abe0-1cd52e276c5b_compressed_-2026-09-07-16.55.11.webp';

export default function KodawariContent() {
  const { t } = useTranslation();

  return (
    <>
      {/* Section Header */}
      <section className="relative pt-16 md:pt-20 pb-12 md:pb-16 px-4 md:px-6 overflow-hidden">
        <img src={headerBgImage} alt="" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-black/50" />
        <div className="relative z-10 max-w-4xl mx-auto text-center">
          <h2 className="font-heading text-2xl md:text-3xl tracking-wider text-white">
            {t('about_label')}
          </h2>
        </div>
      </section>

      {/* Techniques Section */}
      <ScrollReveal as="section" className="py-16 md:py-20 px-4 md:px-6 bg-transparent">
        <div className="max-w-5xl mx-auto">
          <p className="font-heading text-lg md:text-xl text-foreground-600 leading-loose text-center mb-12 max-w-2xl mx-auto reveal-child">
            {t('techniques_title')}
          </p>

          <div className="space-y-16">
            {techniques.map((tech, idx) => (
              <div
                key={tech.titleKey}
                className={`flex flex-col gap-8 ${
                  idx % 2 === 0 ? 'lg:flex-row' : 'lg:flex-row-reverse'
                } items-center`}
              >
                <div className="w-full lg:w-1/2">
                  {tech.imageUrls ? (
                    <div className="grid grid-cols-2 gap-4">
                      {tech.imageUrls.map((url, imgIdx) => (
                        <div key={imgIdx} className="relative overflow-hidden rounded-lg aspect-[4/3]">
                          <img
                            src={url}
                            alt={`${t(tech.titleKey)} ${imgIdx + 1}`}
                            className="w-full h-full object-cover object-top"
                          />
                        </div>
                      ))}
                    </div>
                  ) : (
                    <div className="relative overflow-hidden rounded-lg aspect-[4/3]">
                      <img
                        src={tech.imageUrl}
                        alt={t(tech.titleKey)}
                        className="w-full h-full object-cover object-top"
                      />
                    </div>
                  )}
                </div>
                <div className="w-full lg:w-1/2 text-center lg:text-left">
                  <div className="w-8 h-[1px] bg-accent-400 mx-auto lg:mx-0 mb-4" />
                  <h3 className="font-heading text-lg md:text-xl font-bold tracking-wider text-foreground-900 mb-4">
                    {t(tech.titleKey)}
                  </h3>
                  <p className="text-sm text-foreground-600 leading-loose">
                    {t(tech.descKey)}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </ScrollReveal>

      {/* Ingredients Section */}
      <ScrollReveal as="section" className="py-16 md:py-20 px-4 md:px-6 bg-transparent">
        <div className="max-w-5xl mx-auto">
          <h2 className="font-heading text-lg md:text-xl font-bold tracking-wider text-foreground-900 mb-2 text-center reveal-child">
            {t('sourcing_title')}
          </h2>
          <p className="text-xs tracking-widest text-accent-600 text-center mb-12 font-label reveal-child reveal-delay-1">
            {t('sourcing_subtitle')}
          </p>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {ingredients.map((item) => (
              <div key={item.titleKey} className="bg-background-50 rounded-lg p-6 border border-secondary-200/60 text-center">
                <h3 className="font-heading text-base tracking-wider text-foreground-900 mb-3">
                  {t(item.titleKey)}
                </h3>
                <div className="w-6 h-[1px] bg-accent-400 mx-auto mb-4" />
                <p className="text-sm text-foreground-500 leading-relaxed">
                  {t(item.descKey)}
                </p>
              </div>
            ))}
          </div>
        </div>
      </ScrollReveal>
    </>
  );
}